import { useTranslation as e } from "../../i18n.mjs";
import { FieldFeedback as t } from "../../components/field-feedback/index.mjs";
import { ConfirmationModal as n } from "../../components/confirmation-modal/index.mjs";
import { SortDirectionEnum as r } from "../../enums/pagination-enums.mjs";
import { toast as i } from "../../components/toast/index.mjs";
import { isImageFile as a } from "../../utils/is-image.mjs";
import { areAspectRatiosEqual as o, getAspectRatioNote as ee, getImageAspectRatio as te } from "../../utils/aspect-ratio.mjs";
import { convertFileInfoToDataFile as ne } from "../../utils/convert-file-info-to-data-file.mjs";
import { imageToFile as re } from "../../utils/image-to-file.mjs";
import { FileDetails as ie } from "../../components/file-details/index.mjs";
import { FileDropZone as s } from "../../components/file-drop-zone/index.mjs";
import { useInfiniteDataFiles as c } from "./hooks/use-data-files.mjs";
import { useFileDetails as l } from "./hooks/use-file-details.mjs";
import { useFileActions as u } from "./hooks/use-file-actions.mjs";
import { FileSearch as d } from "./components/file-search.mjs";
import { FileGrid as ae } from "./components/file-grid.mjs";
import { useFileUploader as oe } from "../file-uploader/hooks/use-file-uploader.mjs";
import { ImageCropperModal as se } from "../image-cropper/image-cropper-modal.mjs";
import { FileUploaderModal as ce } from "../file-uploader/file-uploader-modal.mjs";
import { Button as le, Input as ue, breakpointQueries as f, useMediaQuery as p } from "@systemeio/components";
import { useEffect as de, useRef as fe, useState as m } from "react";
import { BadRequest as pe } from "@systemeio/util";
import { twMerge as h } from "tailwind-merge";
import { Fragment as me, jsx as g, jsxs as _ } from "react/jsx-runtime";
//#region src/modules/file-selector/file-selector.tsx
function v({ uploadingFromSource: v, requiredCropping: y = !0, fileUploaderModalProps: b, initialSearchFilters: he, disabledFileTypeSelect: ge, disabledFileSourceSelect: _e, fileSelectorRef: x, onSelect: S, fileManagerApiType: C, renderContent: ve }) {
	y = !!(y && b?.imageCropperModalProps?.imageCropperProps?.aspectRatio);
	let { t: w } = e(), T = p(f.isMobile, { initializeWithValue: !1 }), E = p(f.isTablet, { initializeWithValue: !1 }), D = T || E, [O, k] = m(he ?? {
		name: "",
		source: [],
		type: []
	}), [A, j] = m(O), [M, N] = m(), [P, F] = m(), [I, L] = m(), [R, z] = m(""), [B, ye] = m(), V = c({
		filter: A,
		sortColumn: "createdAt",
		sortDirection: r.Desc,
		fileManagerApiType: C
	}), { resetAndRefetch: H, deleteItemFromData: be, renameItemFromData: U } = V, { deleteFile: xe, downloadFile: Se, renameFile: Ce } = u(), { data: W, isFetching: we } = l({
		id: M?.id,
		fileManagerApiType: C
	}), Te = async () => {
		P && (await xe(P), be(P.id), i.success(w("file_manager.file_deleted_successfully")), F(void 0));
	}, Ee = async (e) => {
		try {
			await Se(e);
		} catch {}
	}, [G, K] = m(), De = async () => {
		if (I) try {
			K(void 0), await Ce({
				id: I.id,
				name: R
			}), U({
				id: I.id,
				name: R
			}), i.success(w("file_manager.file_renamed_successfully")), L(void 0);
		} catch (e) {
			if (e instanceof pe) K(e.errors.fields.name?.join(" "));
			else throw e;
		}
	}, q = fe(void 0), [Oe, J] = m(!1), ke = (e) => {
		q.current?.addFilesToWaitingUpload(e), J(!0);
	};
	de(() => {
		b?.uploaderRef && (b.uploaderRef.current = q.current);
	}, [q.current]), x && (x.current = { setFileUploadModalOpen: J });
	let { createFileUploader: Ae } = oe(C), [je, Y] = m(!1), [Me, X] = m(!1), [Ne, Z] = m(!1), [Pe, Q] = m(), Fe = (e) => {
		Y(!0), Q(e);
	}, $ = () => {
		Y(!1), Q(void 0);
	}, Ie = async (e) => {
		try {
			X(!0);
			let t = await Ae(() => {}).upload({
				file: e,
				source: v
			});
			if (!t) throw Error();
			S(ne(t, v)), H(), $();
		} catch {
			i.error(w("file_manager.error"));
		} finally {
			X(!1);
		}
	}, Le = async () => {
		if (!B) return;
		let e = b?.imageCropperModalProps?.imageCropperProps?.aspectRatio;
		if (!y || !a(B) || !e || isNaN(e)) {
			S(B);
			return;
		}
		try {
			Z(!0);
			let [t, n] = await te(B.path);
			if (o(n, e)) {
				S(B);
				return;
			}
			i(ee(e));
			let r = await re(t, B.name, B.type);
			Fe(r);
		} catch {
			i.error(w("file_manager.error"));
		} finally {
			Z(!1);
		}
	};
	return /* @__PURE__ */ _(me, { children: [
		ve(/* @__PURE__ */ _("div", {
			className: "flex gap-5",
			children: [/* @__PURE__ */ g("div", {
				className: h(M ? "w-1/2" : "w-full", D && M ? "hidden" : "auto"),
				children: /* @__PURE__ */ _("div", {
					className: "flex flex-col gap-5",
					children: [
						/* @__PURE__ */ g(d, {
							isFetching: V.isFetching,
							values: O,
							disabledFileSourceSelect: _e,
							disabledFileTypeSelect: ge,
							onChange: k,
							onSubmit: () => {
								j(O);
							}
						}),
						/* @__PURE__ */ g(ae, {
							dataFilesApi: V,
							onDetails: N,
							onSelect: ye,
							specialElementInGrid: /* @__PURE__ */ g(s, {
								className: "h-full w-full",
								dropZoneClassName: "w-full h-full items-center",
								labelClassName: "text-text-primary",
								onSelect: ke,
								multiple: !0
							}),
							...!C?.isCommon && {
								onDelete: F,
								onDownload: Ee,
								onRename: (e) => {
									L(e), z(e.name);
								}
							}
						}),
						/* @__PURE__ */ _("div", {
							className: "relative bottom-0 flex items-center justify-between",
							children: [/* @__PURE__ */ _("div", {
								className: "text-text-tertiary text-sm",
								children: [
									Number(!!B),
									" ",
									w("file_manager.file_selector.files_selected")
								]
							}), /* @__PURE__ */ g(le, {
								className: "min-w-14",
								disabled: B === void 0,
								isLoading: Ne,
								onClick: () => Le(),
								children: w("file_manager.select")
							})]
						})
					]
				})
			}), M && /* @__PURE__ */ g(ie, {
				className: h(D ? "w-full" : "max-w-[calc(50%-20px)]"),
				fileType: W?.type,
				src: W?.path ?? W?.thumbnail ?? void 0,
				alt: W?.name,
				name: W?.name,
				size: W?.size,
				onClose: () => N(void 0),
				isFetching: we
			})]
		})),
		/* @__PURE__ */ g(n, {
			opened: !!P,
			onClose: () => F(void 0),
			confirmationText: w("file_manager.file_selector.file_deletion_confirmation_text", { file: P?.name }),
			onConfirm: () => Te(),
			status: "error"
		}),
		/* @__PURE__ */ g(n, {
			opened: !!I,
			onClose: () => {
				L(void 0), K(void 0);
			},
			title: w("file_manager.file_selector.rename_file"),
			confirmButtonCaption: w("file_manager.rename"),
			confirmationContent: /* @__PURE__ */ _("label", {
				className: "grid gap-2",
				children: [
					/* @__PURE__ */ g("span", {
						className: "text-text-secondary",
						children: w("file_manager.file_selector.file_name")
					}),
					/* @__PURE__ */ g(ue, {
						"aria-invalid": G ? !0 : void 0,
						"data-invalid": G ? "" : void 0,
						placeholder: w("file_manager.file_selector.enter_new_file_name"),
						value: R,
						onChange: (e) => z(e.target.value)
					}),
					/* @__PURE__ */ g(t, { error: G })
				]
			}),
			onConfirm: () => De()
		}),
		/* @__PURE__ */ g(ce, {
			...b,
			uploaderRef: q,
			opened: Oe,
			source: v,
			showCroppingNote: y,
			onClose: () => J(!1),
			onDone: () => H(),
			fileManagerApiType: C
		}),
		/* @__PURE__ */ g(se, {
			isFetching: Me,
			imageFile: Pe,
			opened: je,
			onClose: $,
			onCrop: Ie,
			actionButtonLabel: w("file_manager.file_upload.crop_and_select_file"),
			...b?.imageCropperModalProps
		})
	] });
}
function y(e) {
	return /* @__PURE__ */ g(v, {
		...e,
		renderContent: (e) => e
	});
}
//#endregion
export { y as FileSelector, v as FileSelectorLayout };
